import React from 'react';

export const MenuWithArrowIcon = ({ size = 20, color = '#000a19', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <line x1="2.5" y1="12" x2="11" y2="12" />
    <polyline
      points="6.5,7.5 2,12 6.5,16.5"
      data-tsd-source="/src/components/AppSidebar.tsx:90:7"
    />
    <line x1="14" y1="6" x2="21.5" y2="6" />
    <line x1="14" y1="12" x2="21.5" y2="12" />
    <line x1="14" y1="18" x2="21.5" y2="18" />
  </svg>
);
